module.exports = __webpack_public_path__ + "img/2.269bdc3c.jpg";